import Bowser from 'bowser';

import useMediaQuery from '@mui/material/useMediaQuery';

import {
  unsupportedBrowsers,
  ipadUnsupportedBrowsers,
} from 'constants/unsupportedBrowsers';

import v from 'components/variables';

const media = {
  mobile: `(max-width: ${v.breakpointMobileMax})`,
  tablet: `(min-width: ${v.breakpointTabletMin}) and (max-width: ${v.breakpointTabletMax})`,
  desktop: `(min-width: ${v.breakpointDesktopMin})`,
};

/*
 * React Hook for getting responsive info.
 * Returns an object that contains 3 keys with boolean values - isMobile, isTable, isDesktop
 */
const useMediaInfo = (config = media) => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const usingIpad = window.navigator.userAgent.match(/iPad/i) != null;

  const isMobile = useMediaQuery(config.mobile);
  const isTablet = useMediaQuery(config.tablet);
  const isDesktop = useMediaQuery(config.desktop);
  const isUnsupported = usingIpad
    ? browser.satisfies(ipadUnsupportedBrowsers)
    : browser.satisfies(unsupportedBrowsers);

  return { isMobile, isTablet, isDesktop, isUnsupported };
};

export default useMediaInfo;
